import {
  checkActionPermission,
  checkPermission,
} from "../../core/routes/RouteValidator";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import $ from "jquery";
import { toast } from "react-hot-toast";
import XConstants from "../../core/config/Constants";
import { useEffect, useState } from "react";
import { AccountService } from "./Service";

const ManageVouchers = () => {
  const service = new AccountService();
  const [type, setType] = useState("Receipt");
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state: any) => state.auth);
  const company = useSelector((state: any) => state.company);

  const getItems = () => {
    try {
      $("#items").DataTable().destroy();
    } catch (e) {
      console.log(e);
    }
    let token = localStorage.getItem("token");
    $("#items").DataTable({
      lengthMenu: [10, 20, 50, 100, 500, 1000],
      pageLength: 100,
      processing: true,
      serverSide: true,
      columnDefs: [
        {
          render: function (data: string, type: any, row: any) {
            return `<p>${data}</p>`;
          },
          targets: 1,
        },
        {
          render: function (data: any, type: any, row: any) {
            return `<button class="btn btn-primary">Details</button>`;
          },
          createdCell: (
            td: any,
            cellData: any,
            rowData: any,
            row: any,
            col: any
          ) => {
            $(td).click((e: any) => {
              navigate(`${location.pathname}/details/${cellData}`);
            });
          },
          targets: 5,
        },
        {
          render: function (data: any, type: any, row: any) {
            return `<button class="btn btn-danger">Delete</button>`;
          },
          createdCell: (
            td: any,
            cellData: any,
            rowData: any,
            row: any,
            col: any
          ) => {
            $(td).click(async (e: any) => {
              let allowed = checkActionPermission(user, company, "delete");
              if (!allowed) {
                toast.error(
                  "You don't have permission to perform this action",
                  {}
                );
                return;
              }
              const res = await service.updateVoucher(rowData[6], {
                deleted: true,
              });
              if (res) {
                toast.success(`Voucher deleted successfully`, {});
                getItems();
              }
            });
          },
          targets: 6,
        },
      ],
      ajax: {
        url: `${XConstants.baseUrl}/company/account/voucher/list`,
        type: "POST",
        contentType: "application/json",
        headers: {
          Authorization: token,
        },
        data: function (d: any) {
          return JSON.stringify({
            ...d,
            type,
          });
        },
      },
    });
  };

  useEffect(() => {
    getItems();
  }, [type]);

  const exportCsv = async () => {
    toast.loading("Creating report...");
    const url = await service.exportVourcher({}, type);

    if (url) {
      window.open(url);
    }
  };

  useEffect(() => {
    if (window.location.pathname.includes("receipt")) {
      setType("Receipt");
    } else if (window.location.pathname.includes("payment")) {
      setType("Payment");
    }
  }, [window.location.pathname]);

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5> {type} Vouchers</h5>
          <div className="list-btn">
            <ul className="filter-list">
              <li onClick={exportCsv}>
                <div
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Download"
                >
                  <a href="#" className="btn-filters" aria-expanded="false">
                    <span>
                      <i className="fe fe-download" />
                    </span>
                  </a>
                </div>
              </li>
              {checkPermission(user, company, `/vouchers/add`) && (
                <li>
                  <Link
                    className="btn btn-primary"
                    to={`/${
                      type === "Payment" ? "payment" : "receipt"
                    }-vouchers/add`}
                  >
                    <i className="fa fa-plus-circle me-2" aria-hidden="true" />
                    Add Voucher
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="card col-12">
          <div className="card-body w-100">
            <div className="table-responsive w-100">
              <table id="items" className="table datatable  w-100">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{type === "Payment" ? "Voucher" : "Receipt"} Number</th>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Date</th>
                    <th>Edit</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageVouchers;
